import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useResolveConversationPageStyles = makeStyles({
    root: {
        ...shorthands.padding('1rem', tokens.spacingHorizontalXXXL),
        alignSelf: 'flex-start',
        justifyItems: 'start',
        justifyContent: 'space-evenly',
        flexDirection: 'column',
        display: 'flex',
        width: '100%',
        maxHeight: '70vh',
        '& > :not(:last-child)': {
            marginBottom: '1.25rem',
        },
    },
    actions: {
        marginTop: 'auto',
        alignSelf: 'end',
    },
    formField: {
        display: 'flex',
        flexDirection: 'column',
        '& > label': {
            marginBottom: tokens.spacingVerticalMNudge,
        },
    },
    textArea: {
        resize: 'vertical',
    },
    helperText: {
        fontSize: tokens.fontSizeBase200,
        color: tokens.colorPaletteYellowForeground1,
        marginBottom: tokens.spacingVerticalS,
    },
    warningText: {
        color: tokens.colorPaletteYellowForeground1,
        fontSize: tokens.fontSizeBase200,
        ...shorthands.padding('8px', '0'),
    },
});
